import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Connector } from 'src/app/models/domain';
import { ConnectorAdapter } from 'src/app/models/domain/adapters';
import { YPMCONNECTORVService } from 'src/generated-clients/connector';

@Injectable({
  providedIn: 'root',
})
export class ConnectorDataService {
  private readonly materialNumberPropertyName: keyof Connector = 'materialNumber';

  public constructor(
    private readonly connectorSetService: YPMCONNECTORVService,
    private readonly connectorAdapter: ConnectorAdapter
  ) {}

  public getConnectorsBySuperDesign(superDesign: string): Observable<Connector[]> {
    // materialNumber is superDesign in Connector, it's not a mistake!
    const filter = `${this.materialNumberPropertyName} eq '${superDesign}'`;

    return this.connectorSetService.yPMCONNECTORVGet(undefined, undefined, filter).pipe(
      rethrowAsSapError(),
      map((res) => {
        if (!res.d?.results) {
          throw new Error('SAP Error');
        }

        return res.d.results.map((construction) =>
          this.connectorAdapter.adaptToDomain(construction)
        );
      })
    );
  }
}
